/**
 * Gets the client (browser) timezone
 *
 * @returns {String} object that offset + dst data
 */
function getClientTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch(e) {
        return null;
    }
}

export {
    getClientTimezone,
};
